import TableGrips from './table-grips';
export default TableGrips;
